import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

function sliderTeacher() {
  new Swiper('.swiper-teacher', {
    modules: [Pagination],
    spaceBetween: 8,
    loop: true,
    grabCursor: true,
    slidesPerView: 1,
    pagination: {
      clickable: true,
      el: '.swiper-pagination'
    },
  });
}
sliderTeacher();